import { jsxs, jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Icons24 } from "../Icons24Sprite/index.js";
import { cn as clsx } from "../../helpers/react.js";
import { IconWrapper } from "../IconWrapper/index.js";
import { withThemeAndSize } from "../withThemeAndSize/index.js";
import '../../assets/index37.css';const tile = "_tile_1oih5_1";
const icon = "_icon_1oih5_16";
const content = "_content_1oih5_20";
const ghost = "_ghost_1oih5_28";
const disabled = "_disabled_1oih5_38";
const colorGhost = "_colorGhost_1oih5_48";
const defaultSubdued = "_defaultSubdued_1oih5_58";
const semantic = "_semantic_1oih5_78";
const s = {
  tile,
  icon,
  content,
  ghost,
  disabled,
  colorGhost,
  defaultSubdued,
  "default": "_default_1oih5_58",
  semantic
};
const CLASS_NAME_MAP = {
  default: s.default,
  ghost: s.ghost,
  "ghost-on-colour": s.colorGhost,
  "default-subdued": s.defaultSubdued,
  semantic: s.semantic,
  disabled: s.disabled
};
const TileHeader = withThemeAndSize(
  forwardRef(
    ({ children, className, iconName, iconSize = "sm", type = "default", contentClassName, ...rest }, ref) => /* @__PURE__ */ jsxs("div", { ...rest, className: clsx(className, s.tile, CLASS_NAME_MAP[type]), ref, children: [
      iconName && /* @__PURE__ */ jsx(IconWrapper, { className: s.icon, size: iconSize, children: /* @__PURE__ */ jsx(Icons24, { name: iconName }) }),
      /* @__PURE__ */ jsx("span", { className: clsx(s.content, contentClassName), children })
    ] })
  )
);
export {
  TileHeader
};
